// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* rechargeSupme.css */


/* Container chứa các tab và nội dung */

.tab-container {
  margin: 20px auto;
  /* Canh giữa container */
  padding: 20px;
  /* Khoảng cách nội dung với viền container */
}


/* Thanh tab */

.nav-tabs {
  list-style-type: none;
  display: flex;
  justify-content: space-around;
  /* Căn các tab đều nhau */
  border-bottom: 2px solid #4E3B31;
  /* Đường kẻ dưới của thanh tab */
  margin-bottom: 20px;
  /* Khoảng cách giữa tab và nội dung */
  padding-bottom: 10px;
  /* Khoảng cách dưới của thanh tab */
}


/* Các tab */

.nav-item {
  flex: 1 1;
  /* Các tab chiếm hết không gian có sẵn */
  text-align: center;
  /* Căn giữa nội dung của tab */
}

.nav-link {
  display: block;
  padding: 10px 0;
  font-size: 16px;
  color: #555;
  text-decoration: none;
  transition: all 0.3s ease;
}

.nav-link:hover {
  color: #4E3B31;
  /* Màu chữ khi hover */
}

.nav-link.active {
  color: #4E3B31;
  /* Màu chữ cho tab active */
  border-bottom: 2px solid #4E3B31;
  /* Border dưới cho tab active */
}


/* Nội dung của tab */

.tab-content {
  background-color: #fff;
  /* Màu nền của nội dung tab */
  padding: 20px;
  border-radius: 8px;
}

.nav-link.active {
  color: white;
  /* Text color when active */
  background-color: #4E3B31;
  /* Background color when active */
  border-radius: 5px;
  /* Rounded corners */
}

.btn-primary {
  margin-top: 20px;
  width: 100%;
  background-color: #4E3B31;
  /* Adjust as needed */
  border: none;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  cursor: pointer;
}

.btn-primary:hover {
  background-color: #4E3B31;
  /* Darker shade for hover effect */
}

.form-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* Space between elements */
  max-width: 100%;
  /* Optional: restrict max width */
  margin: auto;
  /* Center horizontally */
}

.form-control {
  width: 100%;
  /* Ensure full width */
}

.combobox {
  margin-bottom: 10px;
  /* Add margin for spacing */
}

.btn-primary {
  width: 100%;
  /* Make button full width */
}

.mt-3 {
  margin-top: 10px;
  /* Space between elements */
}

.text-danger {
  color: red;
  font-size: 0.875rem;
  /* Adjust the font size as needed */
  margin-top: 0.25rem;
  /* Adds a little space above the error message */
}

/* Modern Container with Effects */
.modern-container {
  max-width: 100%;
  margin: 30px auto;
  padding: 40px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e2e2;
  transition: all 0.3s ease;
}

.modern-container:hover {
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
  /* transform: scale(1.02); */
}

/* Tabs Container */
.tabs {
  display: flex;
  width: 100%;
}

/* Tab Button */
.tab-button {
  flex: 1 1;
  padding: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #4E3B31;
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  text-align: center;
}

.tab-button.active {
  background: #4E3B31;
  color: #fff;
  border-color: #4E3B31;
}

/* Tab Content */
.tab-content {
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  margin-top: 20px;
}

/* Title for Tab Content */
.tab-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

/* Form Row for Aligning Combobox and Price Input */
.form-row {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Combobox Styling */
.modern-combobox {
  width: 100%;
  padding: 12px;
  background-color: #f9f9f9;
  border: 2px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.modern-combobox:focus {
  border-color: #4E3B31;
  box-shadow: 0 0 12px rgba(0, 123, 255, 0.3);
}

.combobox-item {
  padding: 12px;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

.combobox-item:hover {
  background-color: #f1f1f1;
}

/* Price Edit Section */
.price-edit {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Label */
.price-label {
  font-size: 14px;
  color: #333;
}

/* Input */
.modern-input {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border: 2px solid #ccc;
  border-radius: 8px;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.modern-input:focus {
  border-color: #4E3B31;
  box-shadow: 0 0 12px rgba(0, 123, 255, 0.2);
}

/* Save Button with Modern Design */
.modern-button {
  padding: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background-color: #4E3B31;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  width: 100%;
}

.modern-button:hover {
  background-color: #4E3B31;
  transform: scale(1.02);
}

.modern-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

/* Loading Spinner */
.loading-spinner {
  display: block;
  margin: 0 auto;
  padding: 20px;
}

/* Animation Effects */

.btn-link {
  transition: color 0.3s ease, transform 0.3s ease;
}

.btn-link:hover {
  color: #4E3B31;
  transform: scaleX(0.9) scaleY(1.1)
}


.text-theme {
  color:#4E3B31;
  transition: color 0.3s ease;
}

.text-theme:hover {
  color: #17a2b8;
}

.btn-copy {
  background: linear-gradient(135deg, #FFF7A1, #FFEBA1, #FFD700);
  margin-left: 5px;
}

.hoverEffect {
  transition: transform 0.3s ease-in-out;
}

.hoverEffect:hover {
  transform: translateY(-5px);
}

.hoverEffect:hover {
  animation: bounce 0.6s infinite alternate;
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-10px);
  }
}

.info-section {
  background-color: #f9f9f9;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.info-section .text-theme {
  color: #4E3B31;
}

.info-section .text-danger {
  color: #dc3545;
}

.info-section p {
  margin-bottom: 10px;
}

.info-section i {
  margin-right: 5px;
  color: #FFD700;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-100%);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animated-text {
  animation: slideIn 2s ease-in-out;
}

/* Style for the active tab */
.tab-pane.active {
  background-color: #ffffff;
  border: 1px solid #4E3B31;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

/* Style for the active tab header (if you have tab headers) */
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  background-color: #4E3B31;
  color: white;
  border-color: #4E3B31;
}

/* Optional hover effect for active tab */
.tab-pane.active:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

/* Base styles for input and select fields */
input.form-control,
select.form-control {
  border: 1px solid #ced4da;
  border-radius: 4px;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  padding: 10px;
}

/* Focus effect */
input.form-control:focus,
select.form-control:focus {
  border-color: #4E3B31;
  box-shadow: 0 4px 10px rgba(255, 215, 0, 0.5), 0 2px 5px rgba(255, 245, 161, 0.5);
  outline: none;
  transform: scale(1.02);
}

/* Placeholder color transition */
input.form-control::placeholder,
select.form-control::placeholder {
  transition: color 0.3s ease;
}

/* Change placeholder color on focus */
input.form-control:focus::placeholder,
select.form-control:focus::placeholder {
  color: #4E3B31;
}

/* Optional keyframe animation for input fields */
@keyframes pulse {
  0% {
    box-shadow: 0 4px 10px rgba(255, 215, 0, 0.5), 0 2px 5px rgba(255, 245, 161, 0.5);
  }

  50% {
    box-shadow: 0 4px 10px rgba(255, 215, 0, 0.5), 0 2px 5px rgba(255, 245, 161, 0.5);
  }

  100% {
    box-shadow: 0 4px 10px rgba(255, 215, 0, 0.5), 0 2px 5px rgba(255, 245, 161, 0.5);
  }
}

/* Animation effect when the input is focused */
input.form-control:focus,
select.form-control:focus {
  animation: pulse 1s infinite;
}

/* Base styles for labels */
label {
  font-size: 1.1rem;
  color: #333;
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
  transition: color 0.3s ease;
}

/* Hover effect for labels */
label:hover {
  color: #4E3B31;
  cursor: pointer;
}

/* Focus effect for the associated input */
input:focus+label,
select:focus+label {
  color: #4E3B31;
  text-shadow: 0 0 2px rgba(0, 123, 255, 0.5);
}

/* Marquee effect for the header */
/* Container for the marquee */
.marquee-container {
  overflow: hidden;
  position: relative;
  white-space: nowrap;
  width: 100%;
  text-align: center;
}

.marquee {
  display: inline-block;
  animation: marquee 5s linear infinite;
  font-size: 24px;
  font-weight: bold;
  color: #4E3B31;
  background: linear-gradient(135deg, #FFF7A1, #FFEBA1, #FFD700);;
  padding: 10px 20px;
  border-radius: 5px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
}

/* Hover effect to scale the text slightly */
.marquee:hover {
  transform: scale(1.05);
}

/* Keyframes for scrolling right to left */
@keyframes marquee {
  0% {
    transform: translateX(100%);
  }

  50% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

.custom-button {
  background: #4E3B31;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.5s;
}
.custom-button > i {
  color: #fff;
}

.custom-button:hover {
  background: linear-gradient(135deg, #FFEBA1, #FFD700, #FFD700) !important;
}

/* Base style for the tab content */

/* Setting */
.btn-update {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  background-color: #4E3B31;
  border: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.btn-update i {
  margin-right: 8px;
}

.btn-update:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.btn-update:hover {
  background-color: #4E3B31;
}

.btn-update:focus {
  outline: none;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.animated-text--left {
  animation: slideOut 1.5s ease-in-out;
}

@keyframes slideOut {
  from {
    opacity: 0;
    transform: translateX(100%);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.tab-button i {
  margin-right: 8px;
}

.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link{
  color: #4E3B31 !important;
  border-color: #4E3B31 !important;
}


`, "",{"version":3,"sources":["webpack://./src/style/rechargeSupme.css"],"names":[],"mappings":"AAAA,sBAAsB;;;AAGtB,uCAAuC;;AAEvC;EACE,iBAAiB;EACjB,wBAAwB;EACxB,aAAa;EACb,4CAA4C;AAC9C;;;AAGA,cAAc;;AAEd;EACE,qBAAqB;EACrB,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,gCAAgC;EAChC,gCAAgC;EAChC,mBAAmB;EACnB,qCAAqC;EACrC,oBAAoB;EACpB,mCAAmC;AACrC;;;AAGA,YAAY;;AAEZ;EACE,SAAO;EACP,wCAAwC;EACxC,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gCAAgC;EAChC,+BAA+B;AACjC;;;AAGA,qBAAqB;;AAErB;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;AACb;;AAEA,eAAe;AACf;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uDAAuD;EACvD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,UAAU;AACV;EACE,eAAe;EACf,WAAW;AACb;;AAEA,UAAU;AACV;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,cAAc;EACd,aAAa;AACf;;AAEA,sBAAsB;;AAEtB;EACE,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd;AACF;;;AAGA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8DAA8D;EAC9D,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA,8DAA8D;AAC9D;;EAEE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,4CAA4C;AAC5C;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,wDAAwD;EACxD,aAAa;AACf;;AAEA,iBAAiB;AACjB;;EAEE,qBAAqB;EACrB,iFAAiF;EACjF,aAAa;EACb,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;;EAEE,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;;EAEE,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE;IACE,iFAAiF;EACnF;;EAEA;IACE,iFAAiF;EACnF;;EAEA;IACE,iFAAiF;EACnF;AACF;;AAEA,+CAA+C;AAC/C;;EAEE,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;;EAEE,cAAc;EACd,2CAA2C;AAC7C;;AAEA,kCAAkC;AAClC,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,8DAA8D;EAC9D,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA,4CAA4C;AAC5C;EACE,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;;AAEA;EACE,yEAAyE;AAC3E;;AAEA,mCAAmC;;AAEnC,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC","sourcesContent":["/* rechargeSupme.css */\r\n\r\n\r\n/* Container chứa các tab và nội dung */\r\n\r\n.tab-container {\r\n  margin: 20px auto;\r\n  /* Canh giữa container */\r\n  padding: 20px;\r\n  /* Khoảng cách nội dung với viền container */\r\n}\r\n\r\n\r\n/* Thanh tab */\r\n\r\n.nav-tabs {\r\n  list-style-type: none;\r\n  display: flex;\r\n  justify-content: space-around;\r\n  /* Căn các tab đều nhau */\r\n  border-bottom: 2px solid #4E3B31;\r\n  /* Đường kẻ dưới của thanh tab */\r\n  margin-bottom: 20px;\r\n  /* Khoảng cách giữa tab và nội dung */\r\n  padding-bottom: 10px;\r\n  /* Khoảng cách dưới của thanh tab */\r\n}\r\n\r\n\r\n/* Các tab */\r\n\r\n.nav-item {\r\n  flex: 1;\r\n  /* Các tab chiếm hết không gian có sẵn */\r\n  text-align: center;\r\n  /* Căn giữa nội dung của tab */\r\n}\r\n\r\n.nav-link {\r\n  display: block;\r\n  padding: 10px 0;\r\n  font-size: 16px;\r\n  color: #555;\r\n  text-decoration: none;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.nav-link:hover {\r\n  color: #4E3B31;\r\n  /* Màu chữ khi hover */\r\n}\r\n\r\n.nav-link.active {\r\n  color: #4E3B31;\r\n  /* Màu chữ cho tab active */\r\n  border-bottom: 2px solid #4E3B31;\r\n  /* Border dưới cho tab active */\r\n}\r\n\r\n\r\n/* Nội dung của tab */\r\n\r\n.tab-content {\r\n  background-color: #fff;\r\n  /* Màu nền của nội dung tab */\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.nav-link.active {\r\n  color: white;\r\n  /* Text color when active */\r\n  background-color: #4E3B31;\r\n  /* Background color when active */\r\n  border-radius: 5px;\r\n  /* Rounded corners */\r\n}\r\n\r\n.btn-primary {\r\n  margin-top: 20px;\r\n  width: 100%;\r\n  background-color: #4E3B31;\r\n  /* Adjust as needed */\r\n  border: none;\r\n  padding: 0.375rem 0.75rem;\r\n  font-size: 1rem;\r\n  line-height: 1.5;\r\n  border-radius: 0.25rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background-color: #4E3B31;\r\n  /* Darker shade for hover effect */\r\n}\r\n\r\n.form-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  /* Space between elements */\r\n  max-width: 100%;\r\n  /* Optional: restrict max width */\r\n  margin: auto;\r\n  /* Center horizontally */\r\n}\r\n\r\n.form-control {\r\n  width: 100%;\r\n  /* Ensure full width */\r\n}\r\n\r\n.combobox {\r\n  margin-bottom: 10px;\r\n  /* Add margin for spacing */\r\n}\r\n\r\n.btn-primary {\r\n  width: 100%;\r\n  /* Make button full width */\r\n}\r\n\r\n.mt-3 {\r\n  margin-top: 10px;\r\n  /* Space between elements */\r\n}\r\n\r\n.text-danger {\r\n  color: red;\r\n  font-size: 0.875rem;\r\n  /* Adjust the font size as needed */\r\n  margin-top: 0.25rem;\r\n  /* Adds a little space above the error message */\r\n}\r\n\r\n/* Modern Container with Effects */\r\n.modern-container {\r\n  max-width: 100%;\r\n  margin: 30px auto;\r\n  padding: 40px;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\r\n  border: 1px solid #e2e2e2;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.modern-container:hover {\r\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);\r\n  /* transform: scale(1.02); */\r\n}\r\n\r\n/* Tabs Container */\r\n.tabs {\r\n  display: flex;\r\n  width: 100%;\r\n}\r\n\r\n/* Tab Button */\r\n.tab-button {\r\n  flex: 1;\r\n  padding: 12px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #4E3B31;\r\n  background: #f9f9f9;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease, color 0.3s ease;\r\n  text-align: center;\r\n}\r\n\r\n.tab-button.active {\r\n  background: #4E3B31;\r\n  color: #fff;\r\n  border-color: #4E3B31;\r\n}\r\n\r\n/* Tab Content */\r\n.tab-content {\r\n  padding: 20px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  margin-top: 20px;\r\n}\r\n\r\n/* Title for Tab Content */\r\n.tab-title {\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin-bottom: 20px;\r\n  text-align: center;\r\n}\r\n\r\n/* Form Row for Aligning Combobox and Price Input */\r\n.form-row {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n/* Combobox Styling */\r\n.modern-combobox {\r\n  width: 100%;\r\n  padding: 12px;\r\n  background-color: #f9f9f9;\r\n  border: 2px solid #ddd;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\r\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.modern-combobox:focus {\r\n  border-color: #4E3B31;\r\n  box-shadow: 0 0 12px rgba(0, 123, 255, 0.3);\r\n}\r\n\r\n.combobox-item {\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.combobox-item:hover {\r\n  background-color: #f1f1f1;\r\n}\r\n\r\n/* Price Edit Section */\r\n.price-edit {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n/* Label */\r\n.price-label {\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n\r\n/* Input */\r\n.modern-input {\r\n  width: 100%;\r\n  padding: 12px;\r\n  font-size: 16px;\r\n  border: 2px solid #ccc;\r\n  border-radius: 8px;\r\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.modern-input:focus {\r\n  border-color: #4E3B31;\r\n  box-shadow: 0 0 12px rgba(0, 123, 255, 0.2);\r\n}\r\n\r\n/* Save Button with Modern Design */\r\n.modern-button {\r\n  padding: 12px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #fff;\r\n  background-color: #4E3B31;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease, transform 0.2s ease;\r\n  width: 100%;\r\n}\r\n\r\n.modern-button:hover {\r\n  background-color: #4E3B31;\r\n  transform: scale(1.02);\r\n}\r\n\r\n.modern-button:disabled {\r\n  background-color: #6c757d;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Loading Spinner */\r\n.loading-spinner {\r\n  display: block;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n}\r\n\r\n/* Animation Effects */\r\n\r\n.btn-link {\r\n  transition: color 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.btn-link:hover {\r\n  color: #4E3B31;\r\n  transform: scaleX(0.9) scaleY(1.1)\r\n}\r\n\r\n\r\n.text-theme {\r\n  color:#4E3B31;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n.text-theme:hover {\r\n  color: #17a2b8;\r\n}\r\n\r\n.btn-copy {\r\n  background: linear-gradient(135deg, #FFF7A1, #FFEBA1, #FFD700);\r\n  margin-left: 5px;\r\n}\r\n\r\n.hoverEffect {\r\n  transition: transform 0.3s ease-in-out;\r\n}\r\n\r\n.hoverEffect:hover {\r\n  transform: translateY(-5px);\r\n}\r\n\r\n.hoverEffect:hover {\r\n  animation: bounce 0.6s infinite alternate;\r\n}\r\n\r\n@keyframes bounce {\r\n  0% {\r\n    transform: translateY(0);\r\n  }\r\n\r\n  100% {\r\n    transform: translateY(-10px);\r\n  }\r\n}\r\n\r\n.info-section {\r\n  background-color: #f9f9f9;\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.info-section .text-theme {\r\n  color: #4E3B31;\r\n}\r\n\r\n.info-section .text-danger {\r\n  color: #dc3545;\r\n}\r\n\r\n.info-section p {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.info-section i {\r\n  margin-right: 5px;\r\n  color: #FFD700;\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(-100%);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n.animated-text {\r\n  animation: slideIn 2s ease-in-out;\r\n}\r\n\r\n/* Style for the active tab */\r\n.tab-pane.active {\r\n  background-color: #ffffff;\r\n  border: 1px solid #4E3B31;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n/* Style for the active tab header (if you have tab headers) */\r\n.nav-tabs .nav-item.show .nav-link,\r\n.nav-tabs .nav-link.active {\r\n  background-color: #4E3B31;\r\n  color: white;\r\n  border-color: #4E3B31;\r\n}\r\n\r\n/* Optional hover effect for active tab */\r\n.tab-pane.active:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* Base styles for input and select fields */\r\ninput.form-control,\r\nselect.form-control {\r\n  border: 1px solid #ced4da;\r\n  border-radius: 4px;\r\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\r\n  padding: 10px;\r\n}\r\n\r\n/* Focus effect */\r\ninput.form-control:focus,\r\nselect.form-control:focus {\r\n  border-color: #4E3B31;\r\n  box-shadow: 0 4px 10px rgba(255, 215, 0, 0.5), 0 2px 5px rgba(255, 245, 161, 0.5);\r\n  outline: none;\r\n  transform: scale(1.02);\r\n}\r\n\r\n/* Placeholder color transition */\r\ninput.form-control::placeholder,\r\nselect.form-control::placeholder {\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n/* Change placeholder color on focus */\r\ninput.form-control:focus::placeholder,\r\nselect.form-control:focus::placeholder {\r\n  color: #4E3B31;\r\n}\r\n\r\n/* Optional keyframe animation for input fields */\r\n@keyframes pulse {\r\n  0% {\r\n    box-shadow: 0 4px 10px rgba(255, 215, 0, 0.5), 0 2px 5px rgba(255, 245, 161, 0.5);\r\n  }\r\n\r\n  50% {\r\n    box-shadow: 0 4px 10px rgba(255, 215, 0, 0.5), 0 2px 5px rgba(255, 245, 161, 0.5);\r\n  }\r\n\r\n  100% {\r\n    box-shadow: 0 4px 10px rgba(255, 215, 0, 0.5), 0 2px 5px rgba(255, 245, 161, 0.5);\r\n  }\r\n}\r\n\r\n/* Animation effect when the input is focused */\r\ninput.form-control:focus,\r\nselect.form-control:focus {\r\n  animation: pulse 1s infinite;\r\n}\r\n\r\n/* Base styles for labels */\r\nlabel {\r\n  font-size: 1.1rem;\r\n  color: #333;\r\n  font-weight: bold;\r\n  margin-bottom: 5px;\r\n  display: block;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n/* Hover effect for labels */\r\nlabel:hover {\r\n  color: #4E3B31;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Focus effect for the associated input */\r\ninput:focus+label,\r\nselect:focus+label {\r\n  color: #4E3B31;\r\n  text-shadow: 0 0 2px rgba(0, 123, 255, 0.5);\r\n}\r\n\r\n/* Marquee effect for the header */\r\n/* Container for the marquee */\r\n.marquee-container {\r\n  overflow: hidden;\r\n  position: relative;\r\n  white-space: nowrap;\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.marquee {\r\n  display: inline-block;\r\n  animation: marquee 5s linear infinite;\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  color: #4E3B31;\r\n  background: linear-gradient(135deg, #FFF7A1, #FFEBA1, #FFD700);;\r\n  padding: 10px 20px;\r\n  border-radius: 5px;\r\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n/* Hover effect to scale the text slightly */\r\n.marquee:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n/* Keyframes for scrolling right to left */\r\n@keyframes marquee {\r\n  0% {\r\n    transform: translateX(100%);\r\n  }\r\n\r\n  50% {\r\n    transform: translateX(-100%);\r\n  }\r\n\r\n  100% {\r\n    transform: translateX(100%);\r\n  }\r\n}\r\n\r\n.custom-button {\r\n  background: #4E3B31;\r\n  color: #fff;\r\n  padding: 10px 20px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  font-size: 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  transition: all 0.5s;\r\n}\r\n.custom-button > i {\r\n  color: #fff;\r\n}\r\n\r\n.custom-button:hover {\r\n  background: linear-gradient(135deg, #FFEBA1, #FFD700, #FFD700) !important;\r\n}\r\n\r\n/* Base style for the tab content */\r\n\r\n/* Setting */\r\n.btn-update {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 10px 20px;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  color: #fff;\r\n  background-color: #4E3B31;\r\n  border: none;\r\n  border-radius: 5px;\r\n  transition: background-color 0.3s ease;\r\n  cursor: pointer;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.btn-update i {\r\n  margin-right: 8px;\r\n}\r\n\r\n.btn-update:disabled {\r\n  background-color: #cccccc;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.btn-update:hover {\r\n  background-color: #4E3B31;\r\n}\r\n\r\n.btn-update:focus {\r\n  outline: none;\r\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\r\n}\r\n\r\n.animated-text--left {\r\n  animation: slideOut 1.5s ease-in-out;\r\n}\r\n\r\n@keyframes slideOut {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(100%);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n.tab-button i {\r\n  margin-right: 8px;\r\n}\r\n\r\n.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link{\r\n  color: #4E3B31 !important;\r\n  border-color: #4E3B31 !important;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
